// Copyright (c) 2016 Deere & Company

import PinCrossReference from '@deere/cps-it.warranty-model-factory/lib/pin-cross-reference';
import t from 'tcomb';

const PinCrossReferenceReport = t.list(PinCrossReference, 'Report');

export const getDefaultState = () => new PinCrossReferenceReport([]);

export default PinCrossReferenceReport;



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/state/report.js